// let cloneObject = (s) => {
//   let clone = {}
//   for (let [k, v] of Object.entries(s)) {
//     if (v instanceof Array) {
//
//       clone[k] = []
//       for (let o of v) {
//         if (o instanceof Object) {
//           clone[k].push(cloneObject(o))
//         } else {
//           clone[k].push(o)
//         }
//       }
//     } else if (v instanceof Object) {
//       clone[k] = cloneObject(v)
//     } else {
//       clone[k] = v
//     }
//   }
//   return clone
// }

const cloneObject = (o) => {
  return JSON.parse(JSON.stringify(o))
}

const multidevice2DeviceInventory = (multidevice) => {
  const sortByLabel = (a, b) => {
    a = a.label
    b = b.label
    return a == b ? 0 : a < b ? -1 : 1
  }

  const recursiveSort = (l) => {
    l.sort(sortByLabel)
    let foundTheoretical = false
    for (let x of l) {
      if (x.value == 'theoretical') {
        foundTheoretical = true
      }
      if (x.children) {
        recursiveSort(x.children)
      }
    }
    if (foundTheoretical) {
      let theoretical = l.find(x => x.value == 'theoretical')
      l.splice(l.indexOf(theoretical), 1)
      l.splice(0, 0, theoretical)
    }
  }
  const result = {
    analog_filter: { value: 'analog_filter', label: 'Analog filter', children: [], manufacturer: {} },
    digital_filter: { value: 'digital_filter', label: 'Digital filter', children: [], manufacturer: {} },
    digitizer: { value: 'digitizer', label: 'Digitizer', children: [], manufacturer: {} },
    sensor: { value: 'sensor', label: 'Sensor', children: [], manufacturer: {} }
  }
  const processSimpleDevice = (inventoryDevice, deviceDescription) => {
    for (const [manufacturer, models] of Object.entries(deviceDescription)) {
      if (inventoryDevice.manufacturer[manufacturer] == null) {
        inventoryDevice.manufacturer[manufacturer] = {
          value: manufacturer,
          label: manufacturer,
          children: [],
          model: {}
	}
        inventoryDevice.children.push(inventoryDevice.manufacturer[manufacturer])
      }
      for (const [model, description] of Object.entries(models)) {
        if (inventoryDevice.manufacturer[manufacturer].model[model] == null) {
	  inventoryDevice.manufacturer[manufacturer].model[model] = {
	    value: model,
            label: model,
            data: description
	  }
          if (description.serial_number != null) {
            inventoryDevice.manufacturer[manufacturer].model[model].children = description.serial_number.map(x => ({ value: x, label: x }))
          }
          inventoryDevice.manufacturer[manufacturer].children.push(inventoryDevice.manufacturer[manufacturer].model[model])
	}
      }
    }
  }
  for (const [mdManufacturer, mdModels] of Object.entries(multidevice)) {
    for (const [mdModel, mdDescription] of Object.entries(mdModels)) {
      // console.log({ mdManufacturer, mdModel, mdDescription})
      const descriptionKeys = Object.keys(mdDescription)
      descriptionKeys.splice(descriptionKeys.indexOf('instance'), 1)
      for (const deviceType of descriptionKeys) {
        // dispatch each individual device type
        processSimpleDevice(result[deviceType], mdDescription[deviceType])
      }
    }
  }
  recursiveSort(result.sensor.children)
  recursiveSort(result.analog_filter.children)
  recursiveSort(result.digitizer.children)
  recursiveSort(result.digital_filter.children)
  return result
}

export default {
  cloneObject,
  multidevice2DeviceInventory
}
